export const shouldApplyOrderFetch = (requestedOrderId, currentOrderId) => (
  requestedOrderId === currentOrderId
)
